<template>
  <button class="app-menu-mobile-btn" @click="emit('click')">
    <div>
      <Transition appear>
        <div v-if="!open">
          <span class="menu-icon-bar open-icon bar-1" />
          <span class="menu-icon-bar open-icon bar-2" />
          <span class="menu-icon-bar open-icon bar-3" />
        </div>
      </Transition>
      <Transition appear>
        <div v-if="open">
          <span class="menu-icon-bar close-icon bar-1" />
          <span class="menu-icon-bar close-icon bar-2" />
        </div>
      </Transition>
    </div>
  </button>
</template>

<script setup lang="ts">
interface Props {
  open?: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  click: [];
}>();
</script>

<style lang="scss" scoped>
button {
  cursor: pointer;
  position: relative;
  padding: 11.5px 8px;
  display: inline-block;
  width: 40px;
  height: 40px;
  z-index: 1;
  background: transparent !important;
  color: inherit !important;

  > div {
    position: relative;
    width: 100%;
    height: 100%;

    > div {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: scale(1);
      transition: 0.5s;

      &.v-enter-from {
        transform: scale(0);
      }

      &.v-leave-from,
      &.v-leave-active {
        transition: 0;
        opacity: 0;
      }
    }
  }
}

span {
  position: absolute;
  width: 100%;
  height: 3px;
  left: 0;
  border-radius: 3px;
  background: currentColor;
  transition: transform cubic-bezier(0, 2.23, 0, 1.1) 0.75s;

  &.open-icon {
    transform: scale(1);

    &.bar-1 {
      top: 0;
      transition-delay: 0s;
    }

    &.bar-2 {
      top: calc(50% - (0.5 * 3px));
      transition-delay: 0.1s;
    }

    &.bar-3 {
      bottom: 0;
      transition-delay: 0.2s;
    }

    &.v-enter-from,
    &.v-leave-active {
      transform: scale(0);
    }
  }

  &.close-icon {
    background: gray;
    transform-origin: center;

    &.bar-1 {
      top: 0;
      transform: scale(1) rotateZ(45deg) translate(5px, 5px);

      &.v-enter-from,
      &.v-leave-active {
        transform: scale(0) rotateZ(45deg) translate(5px, 5px);
      }
    }

    &.bar-2 {
      bottom: 0;
      transition-delay: 0.1s;
      transform: scale(1) rotateZ(-45deg) translate(5px, -5px);

      &.v-enter-from,
      &.v-leave-active {
        transform: scale(0) rotateZ(45deg) translate(5px, -5px);
      }
    }
  }
}
</style>
